import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  components: {
    // Styles for TextField (Input Field)
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            height: "50px", // Set height for input
            borderRadius: "8px", // Rounded corners
            top: '50%'
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ccc", // Default border color
              borderWidth: "2px", // Default border width
            },
            "&:hover fieldset": {
              borderColor: "#1c1c40", // Border color on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "#3f51b5", // Border color on focus
              borderWidth: "2px", // Border width on focus
            },
          },
          "& .MuiInputBase-input": {
            color: "#333", // Font color
            padding: "10px 12px", // Padding inside the input
          },
        },
      },
    },
    // Styles for TextArea (via OutlinedInput)
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          alignItems: "start", // Prevent shrinking for multiline
          "&.Mui-focused": {
            borderColor: "#3f51b5", // Focus border color
          },
        },
        inputMultiline: {
          padding: "10px", // Padding for textarea content
          lineHeight: "1.5", // Line height for readability
        },
      },
    },
    // Styles for Select
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Rounded corners
        },
        icon: {
          color: "#666", // Color of dropdown arrow
        },
      },
    },
    // Input Label styling (common across TextField and Select)
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#666", // Default label color
          fontSize: "14px", // Font size
          "&.Mui-focused": {
            color: "#3f51b5", // Label color on focus
          },
        },
      },
    },
  },
});

export default theme;
